import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { CUSTOMER_TYPE } from "../../utils/Utils";

import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { getToken } from "../../helper/auth";
import { popupPNCustomerFlowAtom } from '../../state';
const CUSTOMER_TYPE_OPTIONS = Object.keys(CUSTOMER_TYPE).map((c) => ({
  label: CUSTOMER_TYPE[c],
  value: c,
}));

const ReportPNAllCustomer = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [popupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);

  const [updatedAt, setUpdatedAt] = useState();
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });
  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId') || undefined,
    customerType: searchParams.get('customerType') || undefined,
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    GET("/pn-customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.customerType ? { customerType: filter.customerType } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
    }

    if (filter.customerId) {
      params.customerId = filter.customerId;
    }

    if (filter.customerType) {
      params.customerType = filter.customerType;
    }

    GET(
      `/pn-new-customer-money-flow/report-all-customer`,
      params,
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [updatedAt, filter, popupPNCustomerFlow.updatedAt]);

  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => (
        <div
          className="cursor-pointer"
        >
          {item.id}
        </div>
      ),
    },
    {
      Header: "Tên khách hàng",
      accessor: (item) => (
        <div
          className="cursor-pointer"
        >
          {item.name}
        </div>
      ),
    },
    {
      Header: "Tồn đầu kỳ(đ)",
      sortable: true,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.firstDebt || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tăng(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.increaseAmount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Giảm(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={Math.abs(item.decreaseAmount || 0)}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tồn cuối kỳ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.lastDebt || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Ghi chú",
      accessor: () => <></>,
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.customerType ? { customerType: filter.customerType } : {}),
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-new-customer-money-flow/report-all-customer-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <DatePicker
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          onChange={onRangeChange}
                          endDate={rangeDate.end}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions}
                          value={
                            customerOptions.find(
                              (c) => c.value == filter.customerId
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc theo loại"
                          options={CUSTOMER_TYPE_OPTIONS}
                          value={CUSTOMER_TYPE_OPTIONS.find(
                            (c) => c.value === filter.customerType
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerType: val?.value || undefined
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>

                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <h5 className="text-center mt-2">Báo cáo tổng hợp từ {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h5>
                    <Table
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      onRowDoubleClick={(row) => {
                        history.push(`/pn/report-by-customer/${row.id}`)
                      }}
                      headerRow={
                        <tr className="font-weight-bold">
                          <td colSpan={2}>Tổng(đ)</td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.firstDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.increaseAmount || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={Math.abs(summary.decreaseAmount || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                        </tr>
                      }
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ReportPNAllCustomer;
